<template>

    <div>
        <div class="flex mb-4 justify-end">
            <button type="submit" class="btn justify-center px-6 ml-6" :disabled="disabled" @click.prevent="showModal">
                Create API Token
            </button>
        </div>

        <transition
            enter-active-class="ease-out duration-300"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="ease-in duration-200"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true" v-show="display">
                <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" @click="closeModal"></div>

                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                    <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                        <div>
                            <h3>Create API Token</h3>

                            <p class="my-4 text-sm text-gray-500">
                                Tokens you generate can be used to access the {{ $parent.$parent.app_name }} API.
                            </p>

                            <p class="mb-4 text-sm text-error-500" v-if="value.result">Make sure you copy this token, you wont be able to see it again!</p>

                            <div v-if="!value.result">
                                <div class="form-control col-span-6 sm:col-span-4" :class="{ 'form-control-error': value.fieldHasErrors('name') }">
                                    <label for="name">Token Name</label>
                                    <input type="text" name="name" id="name" autocomplete="new-password" v-model="value.data.name">
                                    <span v-if="value.fieldHasErrors('name')">{{ value.getFieldError('name') }}</span>
                                </div>

                            </div>
                            <div v-else>
                                <p class="flex items-center bg-brand-50 p-4 text-sm cursor-pointer" @click.prevent="copyToClipboard">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2 text-brand-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                                    </svg>
                                    <span id="generated-api-token" class="font-medium text-brand-800">{{ value.result.token }}</span>
                                    <span class="ml-2 uppercase text-xs font-medium text-brand-900" v-if="copied">Copied!</span>
                                </p>
                            </div>
                        </div>
                        <div class="mt-5 sm:mt-6 grid grid-cols-2 gap-3 grid-flow-row-dense" v-if="!value.result">
                            <button type="button" class="btn-outline justify-center" @click.prevent="closeModal">
                                Close
                            </button>
                            <button type="button" class="btn justify-center" @click.prevent="createToken" :disabled="value.isFormUpdating()">
                                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" v-if="value.isFormUpdating()">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Create API Token
                            </button>
                        </div>
                        <div class="mt-5" v-else>
                            <button type="button" class="btn-outline w-full justify-center" @click.prevent="closeAndComplete">
                                Copy and Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

    </div>

</template>

<script>
import {PermissionMixin} from "../../support/mixins";

export default {
    name: "CreateApiToken",
    props: ['value', 'disabled'],
    mixins: [PermissionMixin],
    data() {
        return {
            display: false,
            copied: false,
            delay: 1000
        }
    },
    methods: {
        showModal() {
            this.value.resetFormMessages().then(result => {
                this.display = true;
            });
        },
        closeModal() {
            this.display = false;
        },
        closeAndComplete() {
            let vm = this;

            vm.copyToClipboard().then(result => {
                vm.closeModal();
                vm.value.resetFormMessages()
            });
        },
        copyToClipboard() {
            let vm = this;

            return new Promise(resolve => {
                let range = document.createRange();

                range.selectNode(document.getElementById('generated-api-token'));
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
                document.execCommand("copy");
                window.getSelection().removeAllRanges();

                vm.copied = true;

                setTimeout(function () {
                    vm.copied = false;
                    resolve(true);
                }, vm.delay);
            });
        },
        createToken() {
            this.value.resetFormMessages().then(result => {
                this.$emit('createToken');
            }).catch(error => this.handleError(error));
        }
    }
}
</script>


